import CreateController from '../events/components/wizard/Controller';

export default function (api, socket) {
    return CreateController(api, socket);
};
